module.exports = __webpack_public_path__ + "static/media/starfilled.79fc4cf0.svg";